<template>
  <main>
    <div class="container">
      <section class="section">
        <div class="section__block">
          <h1 class="text-center">Beitrag erstellen</h1>
        </div>
        <div class="section__block">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-8">
              <div class="alert alert-danger" v-if="errorMessage" role="alert">
                {{ errorMessage }}
              </div>
              <div class="alert alert-success" v-if="successMessage" role="alert">
                {{ successMessage }}
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-12 col-lg-8">
              <form @submit.prevent="submit">
                <div class="mb-4">
                  <label for="title" class="form-label">Überschrift</label>
                  <input type="text" class="form-control" name="title" id="title" v-model="title"
                         placeholder="Überschrift hier eintragen">
                </div>
                <div class="mb-4">
                  <label for="text" class="form-label">Inhalt</label>
                  <textarea class="form-control" name="text" id="text" v-model="text" rows="10"
                            placeholder="Inhalt für neue Nachricht"></textarea>
                </div>
                <div class="mb-4">
                  <label for="image" class="form-label">Bild Hochladen (Optional)</label>
                  <input type="file" @change="handleFileChange" name="image" id="image" class="form-control"/>
                </div>
                <div v-if="validUser">
                  <p>Für welchen Verein soll der Beitrag veröffentlicht werden?:</p>
                  <div v-for="(club, index) in clubs" :key="index" class="radio-group">
                    <input
                        type="radio"
                        :id="'club-' + club.id"
                        :value="club.id"
                        v-model="selectedClub"
                        class="radio-input"
                    />
                    <label :for="'club-' + index" class="radio-label">{{ club.name }}</label>
                  </div>
                </div>
                <input type="hidden" name="clubId" :value="selectedClub"/>

                <div class="d-flex justify-content-center">
                  <button type="submit" class="btn btn-primary">Absenden</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

    </div>
  </main>
</template>

<script>
import {ref, onMounted} from 'vue';
import axios from "axios";

export default {
  setup() {
    const title = ref('');
    const text = ref('');
    const file = ref(null);
    const errorMessage = ref('');
    const successMessage = ref('');

    const handleFileChange = (event) => {
      // set the file to the reactive ref when the user selects a file
      file.value = event.target.files[0];
    };

    // Reaktive Variablen für `user` und `clubs`
    const user = ref(null);
    const clubs = ref([]);
    const validUser = ref(false);
    const selectedClub = ref("1"); // Reaktive Variable für den ausgewählten Club

    const submit = async () => {
      // Validate form fields
      if (!title.value || !text.value) {
        errorMessage.value = 'Bitte füllen Sie die Pflichtfelder aus!';
        return;
      }

      const formData = new FormData();

      // Append regular fields
      formData.append("title", title.value);
      formData.append("text", text.value);

      // Append the file if available
      if (file.value) {
        formData.append("image", file.value);
      }
      formData.append("clubId", selectedClub.value);

      // Submit form (simulating an API call)
      try {
        // Uncomment this when you implement the API request
        await axios.post('http://localhost:8082/gemeinde/news', formData);

        // Reset form after successful submission
        title.value = '';
        text.value = '';
        file.value = null;
        errorMessage.value = '';

        successMessage.value = 'Beitrag wurde erfolgreich erstellt!';
      } catch (error) {
        errorMessage.value = 'Ein Fehler ist aufgetreten';
        console.error(error);
      }
    };

    // Hole die Daten aus localStorage und setze sie in die Variablen
    onMounted(() => {
      const userCheckResult = JSON.parse(localStorage.getItem("userCheckResult"));

      if (userCheckResult) {
        user.value = userCheckResult.user;  // Setze den Benutzernamen
        clubs.value = userCheckResult.clubs; // Setze die Clubs
        validUser.value = userCheckResult.validUser // Login Erfolgreich?

        // Default auf ersten Club setzen (wenn vorhanden)
        if (clubs.value.length > 0) {
          selectedClub.value = clubs.value[0].id;
        }
      }
    });

    // Rückgabe der reaktiven Variablen
    return {
      submit,
      text,
      title,
      file,
      errorMessage,
      successMessage,
      handleFileChange,
      user,
      clubs,
      selectedClub,
      validUser
    };
  }
};
</script>

<style scoped>
/* Abstand zum Radio-Button */
.radio-group {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

/* Abstand neben dem Radio-Button */
.radio-input {
  margin-right: 10px; /* Abstand nach dem Radio-Button */
}

/* Optional: Abstand zwischen dem Radio-Button und dem Label */
.radio-label {
  margin-left: 5px;
}
</style>
